import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-je-application',
  templateUrl: './je-application.component.html',
  styleUrls: ['./je-application.component.scss']
})
export class JeApplicationComponent implements OnInit {

  constructor(private route: ActivatedRoute, private cryptoJsService: CryptoJsService, private router: Router) { }


  items: any[];
  autoId: any;
  appId: any;
  userRole:any
  activeItem: any;

  ngOnInit() {
    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.userRole =sessionStorage.getItem('userRole')
        if( this.userRole=='DD Associate'){
          this.items = [
            { label: 'Basic', icon: 'pi pi-fw pi-home', routerLink: `/${parentRoute}/application/basic`, queryParams: { autoId: this.autoId , appId : this.appId } },
            { label: 'Attachment', icon: 'pi pi-fw pi-calendar', routerLink: `/${parentRoute}/application/image-attachment`, queryParams: { autoId: this.autoId , appId : this.appId } },
            { label: 'Survey Detail', icon: 'pi pi-fw pi-calendar', routerLink: `/${parentRoute}/application/finance`, queryParams: { autoId: this.autoId , appId : this.appId } },
            // { label: 'Submit', icon: 'pi pi-fw pi-pencil', routerLink: `/${parentRoute}/application/attachment`, queryParams: { autoId: this.autoId , appId : this.appId } },
          ];
        }
        else{
        this.items = [
          { label: 'Basic', icon: 'pi pi-fw pi-home', routerLink: `/${parentRoute}/application/basic`, queryParams: { autoId: this.autoId , appId : this.appId } },
          { label: 'Survey Detail', icon: 'pi pi-fw pi-calendar', routerLink: `/${parentRoute}/application/finance`, queryParams: { autoId: this.autoId , appId : this.appId } },
          { label: 'Attachment', icon: 'pi pi-fw pi-pencil', routerLink: `/${parentRoute}/application/attachment`, queryParams: { autoId: this.autoId , appId : this.appId } },
        ];
      }
      }
      );
  }



}
